// FAQ-sectie: onderwerp-tabs links wisselen het zichtbare vraag/antwoord-paneel rechts.
// Event-delegatie op document, zodat het ook werkt na her-renders in de theme-editor.
document.addEventListener('click', (event) => {
  const button = event.target.closest('.faq-topic');
  if (!button) return;

  const section = button.closest('.faq');
  if (!section) return;

  const index = button.dataset.faqTopic;

  section.querySelectorAll('.faq-topic').forEach((tab) => {
    const isActive = tab === button;
    tab.classList.toggle('faq-topic--active', isActive);
    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  section.querySelectorAll('[data-faq-panel]').forEach((panel) => {
    panel.hidden = panel.dataset.faqPanel !== index;
  });
});
